import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import Sidebar from "../layout/Sidebar";
import Navbar from "../layout/Navbar";

import Maincontent from "./Maincontent";

import { Layout, Breadcrumb } from "antd";
const { Content } = Layout;

const Contact = () => {
  const [updatelist, setUpdatelist] = useState(true);
  

  return (
    <>
      <Layout className="window-frame">
        <Sidebar />
        <Layout className="site-layout">
          <Navbar />
          <Content className="main-frame-content">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Petty Cash</Breadcrumb.Item>
            </Breadcrumb>
            <Maincontent  />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default connect()(Contact);
